import About from "@/components/about";
import allBills from "@/components/allBills";
import allPatients from "@/components/allPatients";
import billingModule from "@/components/billingModule";
import Dashboard from "@/components/Dashboard";
import FormBrandList from "@/components/FormBrandList.vue";
import FormEmployeeRegister from "@/components/FormEmployeeRegister.vue";
import FormMonthlyReport from "@/components/FormMonthlyReport.vue";
import FormPatientList from "@/components/FormPatientList.vue";
import FormPeriodicBrandCount from "@/components/FormPeriodicBrandCount.vue";
import FormPharmaCompanyList from "@/components/FormPharmaCompanyList.vue";
import FormVisitRegister from "@/components/FormVisitRegister.vue";
import AppointmentsOn from "@/components/AppointmentsOn.vue";
import Header from "@/components/Header";
import Login from "@/components/Login";
import prescription from "@/components/prescription";
import profileAdd from "@/components/profileAdd";
import profileEdit from "@/components/profileEdit";
import vitalsPost from "@/components/vitals";
import Vue from "vue";
import Router from "vue-router";

// import  from ''
// const masterPatientData = resolve => require(['@/components/AddPatient.vue'], resolve)
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/dashboard/:clinicId/:doctorId",
      name: "HelloWorld",
      components: {
        header: Header,
        default: Dashboard
        // addpatient:AddPatient
      }
    },
    // {
    //   path: '/vitals',
    //   name: 'vitals',
    //   components: {
    //     header: Header,
    //     masterPatientDataStatic: masterPatientDataStatic
    //   }
    // },
    {
      path: "/vitals/:appId/:ptId",
      name: "vitalsPost",
      props: true,
      // beforeEnter: checkAuth,
      components: {
        header: Header,
        vitalsPost: vitalsPost
      }
    },
    {
      path: "/billing/:appId/:ptId",
      name: "billing",
      props: true,
      components: {
        header: Header,
        billingModule: billingModule
      }
    },
    {
      path: "/billing/view/:appId/:ptId",
      name: "billingView",
      props: true,
      components: {
        header: Header,
        allBills: allBills
      }
    },
    {
      path: "/prescription/:appId",
      name: "prescription",
      props: true,
      components: {
        header: Header,
        prescription: prescription
      }
    },
    {
      path: "/profile/add",
      name: "profileAdd",
      props: true,
      components: {
        header: Header,
        profileAdd: profileAdd
      }
    },
    {
      path: "/profile/edit/:appId/:ptId",
      name: "profileEdit",
      props: true,
      components: {
        header: Header,
        profileEdit: profileEdit
      }
    },
    {
      path: "/appointments-on/:date",
      name: "appointmentsOn",
      props: true,
      components: {
        header: Header,
        forms: AppointmentsOn
      }
    },
    {
      path: "/forms/employee-registration",
      name: "forms-employee-registration",
      props: true,
      components: {
        header: Header,
        forms: FormEmployeeRegister
      }
    },
    {
      path: "/forms/visit-register",
      name: "forms-visit-register",
      props: true,
      components: {
        header: Header,
        forms: FormVisitRegister
      }
    },
    {
      path: "/forms/patient-list",
      name: "forms-patient-list",
      props: true,
      components: {
        header: Header,
        forms: FormPatientList
      }
    },

    {
      path: "/forms/brand-list",
      name: "forms-brand-list",
      props: true,
      components: {
        header: Header,
        forms: FormBrandList
      }
    },

    {
      path: "/forms/pharma-company-list",
      name: "forms-pharma-company-list",
      props: true,
      components: {
        header: Header,
        forms: FormPharmaCompanyList
      }
    },
    {
      path: "/forms/periodic-brand-count",
      name: "forms-periodic-brand-count",
      props: true,
      components: {
        header: Header,
        forms: FormPeriodicBrandCount
      }
    },

    {
      path: "/forms/monthly-report",
      name: "forms-monthly-report",
      props: true,
      components: {
        header: Header,
        forms: FormMonthlyReport
      }
    },

    {
      path: "/allPatients",
      name: "allPatients",
      props: true,
      components: {
        header: Header,
        allPatients: allPatients
      }
    },
    {
      path: "/",
      name: "login",
      components: {
        login: Login
        // header:Header,
        // default:Dashboard,
        //   addpatient:AddPatient
      }
    },
    {
      path: "/about",
      name: "About",
      props: true,
      components: {
        header: Header,
        default: About
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js